// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import store from '../store'
import './assets/icons/index.js'
import 'default-passive-events'
import VueClipboard from 'vue-clipboard2'

Vue.use(ElementUI)
Vue.use(VueClipboard)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
}, router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
    if (store.getters.Flag && localStorage.getItem('Flag')) {
      next()
    } else {
      next({
        path: '/login'
        // query: {
        //   redirect: to.meta.redirect}
        // }
      })
    }
  } else {
    next()
  }

  // 如果不是代理跳转到首页
  if (to.fullPath === '/proxy') {
    if (store.getters.proxy === 'proxy') {
      next()
    } else {
      next({
        path: '/home'
      })
    }
  }
  // 如果本地 存在 token 则 不允许直接跳转到 登录页面
  if (to.fullPath === '/login' || to.fullPath === '/registered' || to.fullPath === '/forget') {
    if (store.getters.Flag === 'isLogin') {
      next({
        path: '/home'
      })
    } else {
      next()
    }
  }
}))



// WEBPACK FOOTER //
// ./src/main.js